/**
 * Feeds Module Constants - Brand New Clean Architecture
 * Organized constants for better maintainability
 */

// UI Constants
export const PORTAL_GAP_THRESHOLD = 200;

// Message Types
export const MESSAGE_TYPE = {
  TEXT: 'text',
  ANNOUNCEMENT: 'announcement',
  SYSTEM: 'system',
  LEGACY: 'legacy',
  ANNOUNCEMENT_REFERENCE: 'announcement_reference',
};

// Feed Types
export const FEED_TYPE = {
  DM: 'DM',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  CHANNEL: 'CHANNEL',
};

// Feed Permissions
export const FEED_PERMISSIONS = {
  MESSAGING_DISABLED: 'messaging_disabled',
  LEARNERS_CAN_SEND: 'learners_can_send_message',
  LEARNER_CAN_REPLY: 'learner_can_reply',
  REACTIONS_ENABLED: 'reactions_enabled',
};

// Membership Types
export const MEMBERSHIP_TYPE = {
  PERSON: 'person',
  LOCATION: 'location',
  GROUP: 'group',
};

// Role Types
export const ROLE = {
  LEARNER: 'Learner',
};

// Reaction Types
export const REACTION_TYPE = {
  LIKE: 'like',
  LOVE: 'love',
  THUMBS_UP: 'thumbs_up',
  THUMBS_DOWN: 'thumbs_down',
  SMILE: 'smile',
};

// Sort Options
export const SORT_OPTIONS = {
  MOST_RECENT: 'most_recent_activity',
  OLDEST: 'oldest',
  NAME_AZ: 'sender_name_az',
  NAME_ZA: 'sender_name_za',
};

// Tab Constants
export const TAB_NAMES = {
  ALL: 'All',
  MESSAGES: 'Messages',
  ANNOUNCEMENTS: 'Announcements',
  CHANNELS: 'Channels',
};

// Announcement Types - for consistency
export const ANNOUNCEMENT_TYPES = {
  MY_ANNOUNCEMENTS: 'My Announcement',
  ALL_ANNOUNCEMENTS: 'All Announcement',
};

// Navigation Event Types
export const NAVIGATION_EVENTS = {
  NAVIGATE_TO_DM: 'navigate_to_dm',
};

// Socket Event Types
export const SOCKET_EVENTS = {
  FEED_CREATED: 'feed_created',
  FEED_MESSAGE_SENT: 'feed_message_sent',
  FEED_UPDATED: 'feed_updated',
  MESSAGE_RECEIVED: 'message_received',
  COMMUNICATION_EVENT: 'COMMUNICATION_EVENT',
};

// Pagination Constants - Updated for new paginated APIs
export const PAGINATION_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 20,
  DEFAULT_DM_PAGE_SIZE: 10,
  DEFAULT_ANNOUNCEMENT_PAGE_SIZE: 20,
  DEFAULT_FEED_SIZE: 10,
  MAX_MESSAGE_LENGTH: 32000,
  SOCKET_ROOM_MAX_FEEDS: 50000, // Large number for getAllFeeds to join all socket rooms
  DEFAULT_DM_SORT_BY: 'createdAt,asc',
};

// Error Messages
export const ERROR_MESSAGES = {
  ERR_MESSAGING_DISABLED: {
    code: 'FEED_007',
    message: 'Messaging is disabled for this feed',
  },
  ERR_LEARNER_CANNOT_SEND: {
    code: 'FEED_008',
    message: 'Learners are not allowed to send messages in this feed',
  },
  ERR_LEARNER_CANNOT_REPLY: {
    code: 'FEED_009',
    message: 'Learners are not allowed to reply to messages in this feed',
  },
  ERR_MESSAGE_LIMIT_EXCEEDED: {
    code: 'FEED_010',
    message: 'You have reached the consecutive message limit in this feed. Please wait before sending more messages.',
  },
  ERR_ADMIN_REQUIRED: {
    code: 'FEED_011',
    message: 'Only administrators can delete messages',
  },
  ERR_CANNOT_EDIT_MESSAGE: {
    code: 'FEED_012',
    message: 'Cannot edit this message - either not the sender or edit time limit exceeded',
  },
};

// Helper function to format error messages with parameters
export const formatErrorMessage = (errorKey, ...args) => {
  const error = ERROR_MESSAGES[errorKey];
  if (!error) {
    return 'Unknown error';
  }

  // Simple string formatting for JavaScript (replaces %s with arguments)
  let formattedMessage = error.message;
  args.forEach((arg, index) => {
    formattedMessage = formattedMessage.replace('%s', arg);
  });

  return formattedMessage;
};

export const TagEnum = {
  New: 0,
  Private: 1,
  LimitedReplies: 2,
  MonitoredByAdmin: 3,
  MessageLimit: 4,
  ViewOnly: 5,
  LearnerViewOnly: 6,
  Locked: 7
};